import { render, staticRenderFns } from "./IconEditorPick.vue?vue&type=template&id=aa1b277c"
import script from "./IconEditorPick.vue?vue&type=script&lang=js"
export * from "./IconEditorPick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports